import UseAppPage from 'Pages/Common/UseApp/UseAppPage';
import LoginWithPasswordScreen from 'Pages/Guest/Auth/FallbackLogin/LoginWithPasswordScreen';
import ForgotPasswordPage from 'Pages/Guest/ForgotPassword';
import LanguageQuestionScreen from 'Pages/Guest/Onboarding/PreauthQuestionScreens/LanguageQuestionScreen';
import NameQuestionScreen from 'Pages/Guest/Onboarding/PreauthQuestionScreens/NameQuestionScreen';
import { lazy } from 'react';
import { Navigate, RouteObject, useLocation } from 'react-router-dom';
import GuestWrapper from './GuestWrapper';
import ReferralIntroScreen from 'Pages/Guest/Onboarding/ReferralIntroScreen';
const LandingPage = lazy(
    () => import('Pages/Guest/Onboarding/Flow/OnboardingFlow'),
);

const EmailInputScreen = lazy(
    () => import('Pages/Guest/Auth/EmailLoginScreen'),
);
const ConfirmCodeScreen = lazy(
    () => import('Pages/Guest/Auth/ConfirmCodeScreen'),
);
const AuthChoiceScreen = lazy(
    () => import('Pages/Guest/Onboarding/AuthChoiceScreen'),
);
const CountryQuestionScreen = lazy(
    () =>
        import(
            'Pages/Guest/Onboarding/PreauthQuestionScreens/CountryQuestionScreen'
        ),
);

const LegacyWelcomeInvitedRedirect = (): React.JSX.Element => {
    const location = useLocation();

    return <Navigate to={`/landing${location.search}`} replace />;
};

const registerRoutes: RouteObject[] = [
    {
        path: '/register/email',
        element: <EmailInputScreen />,
    },
    {
        path: '/register/name',
        element: <NameQuestionScreen />,
    },
    {
        path: '/register/language',
        element: <LanguageQuestionScreen />,
    },
    {
        path: '/register/country',
        element: <CountryQuestionScreen />,
    },
];
const guestRoutes: RouteObject = {
    element: <GuestWrapper />,
    children: [
        {
            path: 'login',
            element: <EmailInputScreen isLogin={true} />,
        },
        {
            path: 'auth',
            element: <AuthChoiceScreen />,
        },
        {
            path: 'landing',
            element: <LandingPage />,
        },
        {
            path: 'welcome-referral',
            element: <ReferralIntroScreen />,
        },
        {
            path: 'welcome-invited',
            element: <LegacyWelcomeInvitedRedirect />,
        },
        {
            path: '/confirm',
            element: <ConfirmCodeScreen />,
        },
        {
            path: '/loginfallback',
            element: <LoginWithPasswordScreen />,
        },
        {
            path: '/password/forgot',
            element: <ForgotPasswordPage />,
        },
        {
            path: '/useapplogin',
            element: <UseAppPage />,
        },
        ...registerRoutes,
    ],
};

export default guestRoutes;
